//global variable
let subscriberMeData = null;
// Search filter
document.addEventListener('DOMContentLoaded', () => {
  const box = document.querySelector('.search_box');
  const body = document.querySelector('.search_box_body');
  const input = document.getElementById('collection_search_input');
  const resultList = document.querySelectorAll('.collection_name');
  const noMsg = document.querySelector('.no_results_message');

  if (!box || !body) return;

  // Toggle dropdown and class
  box.addEventListener('click', (e) => {
    e.stopPropagation();
    const isOpen = body.classList.toggle('open');
    box.classList.toggle('active', isOpen);
  });

  // Close on outside click
  document.addEventListener('click', (e) => {
    if (!box.contains(e.target) && !body.contains(e.target)) {
      body.classList.remove('open');
      box.classList.remove('active');
    }
  });

  // Filter on input
  input.addEventListener('input', () => {
    const query = input.value.toLowerCase().trim();
    let matchCount = 0;

    resultList.forEach((link) => {
      const item = link.closest('li');
      const match = link.textContent.toLowerCase().includes(query);
      item.style.display = match ? 'block' : 'none';
      if (match) matchCount++;
    });

    noMsg.style.display = query && matchCount === 0 ? 'block' : 'none';
  });

  // css js 
  const countryFilter = document.getElementById('CountryFilter');
  const productItems = document.querySelectorAll('#product-grid > li');

  countryFilter?.addEventListener('change', function () {
    const selected = this.value;

    productItems.forEach((item) => {
      const country = item.dataset.country;
      if (!selected || selected === 'all' || selected === country) {
        item.style.display = 'block';
      } else {
        item.style.display = 'none';
      }
    });
  });

});

// this js for app fuctionlity 
const myESIMAPI = apiBase ? (apiBase + "/esims") : null;

// to get all plans, getMyESIMData
const getMyESIMData = async () => {

  try {
    const gbToken = await updateGBToken();
    const response = await fetch(myESIMAPI, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${gbToken}`
      }
    });

    if (!response.ok) {
      // Try to parse error as JSON, fallback to text
      let errorDetail;
      try {
        errorDetail = await response.json();
      } catch {
        errorDetail = await response.text();
      }
      console.error("Error in esimsAPI: Network or API failure", errorDetail);
      return null;
    }

    const result = await response.json();
    return (Array.isArray(result) && result.length > 0) ? result : null;

  } catch (error) {
    console.error("Error in esimsAPI: Exception thrown", error);
    return null;
  }
}



function toTitleCase(name) {
  return name.toLowerCase().split(' ').filter(word => word.trim() !== '').map(word => word[0].toUpperCase() + word.slice(1)).join(' ');
}

const renderESIMCards = async (esimsData, selectedPreferredImsiId) => {
  console.log(esimsData, selectedPreferredImsiId,'esimsData, selectedPreferredImsiId');
  const white_arrow_icon_svg = `<img src="${window.whiteArrowIconUrl}" alt="arrow" width="16" height="16" style="vertical-align:middle;">`;
  if (esimsData && esimsData?.length > 0) {
    const eSIMsList = document.getElementById('e_sims_list');
    eSIMsList.innerHTML = ''; // clear existing content
    esimsData.forEach(esim => {
      //check the IMSID
      if (selectedPreferredImsiId == esim.imsiId) {
        console.log(selectedPreferredImsiId == esim.imsiId,'selectedPreferredImsiId == esim.imsiId')
        const eSIMStatus = esim.status === 'ENABLED' ? 'Active' : (esim.status === 'UNAVAILABLE' || esim.status === 'DELETED') ? 'Deleted' : 'Inactive';

        const card = `  <div class="e_sim_card">
                <span class="fw_500 card_status flex_c ${eSIMStatus}">
                  <span class="dot_icon"></span><span>${eSIMStatus}</span>
                </span>
                <div class="crd_content">
                  <div class="content_l">
                    <div class="sim_name fw_600">${esim?.name}</div>
                    <div class="sim_iccid fw_500"><span style="color: var(--color-black)">ICCID :</span>${esim?.iccid}</div>
                  </div>
                  <div class="content_l">
                    <div class="arow_icn flex_c js_go_to_checkout" data-esim-id="${esim.esimId}">
                      ${white_arrow_icon_svg}
                    </div>
                  </div>
                </div>
              </div>`
        eSIMsList.innerHTML += card; // append each card
      }
    });

  } else {
    console.log('no esim found');
  }
  return true
}

//  Centralized Email + eKYC check
const canProceedToCheckout = async (iseKycEnabled) => {
  const checkoutBtn = document.getElementById('checkout_btn');
  const emailValificationDiv = document.getElementById('email_valification_div');
  // calling agin for updated data
  subscriberMeData = await subscriberMe();

  //1.is email verified 
  if (!subscriberMeData || subscriberMeData.verifiedAccount != true) {
    console.log('subscriberMeData not verified. Cannot proceed to checkout.', subscriberMeData, window.collection_metafields?.eKycRequired);
    checkoutBtn?.classList.remove('hidden');
    emailValificationDiv?.classList.add('hidden');
    return false;
  }
  //2. from the collection we are checking is ekyc require
  // also if cache api gave ekyc-enable true 
  console.log('collection ekyc require is eky enable', window.collection_metafields?.eKycRequired, iseKycEnabled)
  if (window.collection_metafields?.eKycRequired && iseKycEnabled) {
    console.log('eKYC required for this collection.');
    const ekyc = subscriberMeData.eKycStatus;
    if (['pending', 'initiated', 'ongoing', 'failed', 'rejected'].includes(ekyc)) {
      checkoutBtn?.classList.add('hidden');
      emailValificationDiv?.classList.remove('hidden');
      return false;
    }
  }
  console.log('eKYC not required or completed successfully.', subscriberMeData.verifiedAccount, subscriberMeData.eKycStatus, window.collection_metafields?.eKycRequired);
  // All conditions passed → allow checkout
  checkoutBtn?.classList.remove('hidden');
  emailValificationDiv?.classList.add('hidden');

  return true;
}

//this function details popup
function setTopUpAvailability() {
  const yesEl = document.querySelector('.top_up_available_yes');
  const noEl = document.querySelector('.top_up_available_no');

  if (!cacheData?.cache?.config){
  console.log('cacheData not found')
  };

  if (cacheData?.cache?.config?.topupPlansMasterEnabled == true) {
    yesEl?.classList.remove('hidden');
    noEl?.classList.add('hidden');
    console.log('topupPlansMasterEnabled - Yes');
  } else {
    yesEl?.classList.add('hidden');
    noEl?.classList.remove('hidden');
    console.log('topupPlansMasterEnabled - No');
  }
}
function setIdentityVerifcaton() {
  const yesEl = document.querySelector('.identity_required');
  const noEl = document.querySelector('.identity_not_required');
  const eKyc_btn = document.querySelector('.adding_hidden_guest_user');

  if (!cacheData?.cache?.config){
    console.log('cacheData not found')
  };

  if (cacheData?.cache?.config?.eKycEnabled == true) {
    yesEl?.classList.remove('hidden');
    noEl?.classList.add('hidden');
    eKyc_btn?.classList.remove('hidden')

    console.log('identity_required - Yes');
  } else {
    yesEl?.classList.add('hidden');
    noEl?.classList.remove('hidden');
    eKyc_btn?.classList.add('hidden')

    console.log('identity_not_required - No guest_user');
  }
}


document.addEventListener('DOMContentLoaded', async () => {
  //console.log('working', window.collection_metafields);

  // get catch data
  if (cacheData == null) {
    cacheData = await getCacheData()
  }

  const productGridItems = document.querySelectorAll('#product-grid .grid__item');
  const detailBox = document.querySelector('.show_the_product_detials');
  const productNameEl = detailBox.querySelector('.product-name');
  const productPriceEl = detailBox.querySelector('.product-price');
  const productComparePriceEl = detailBox.querySelector('.product-compare-price');
  const collectionNameEl = detailBox.querySelector('.collection-name');
  const checkout_btn = detailBox.querySelector('#checkout_btn');
  const form = document.getElementById('buyNowForm');
  const checkoutBtn = document.getElementById('checkout_btn');
  const verifyBtn = document.getElementById('pages_verification_instructions');
  const emailValificationDiv = document.getElementById('email_valification_div');

  let selectedVariantId = null;
  let selectedPreferredImsiId = null;
  let selectedProductId = null;
  let selectedCountryKey = null;
  let selectedCurrencyKey = null;
  let selectedProductTitle = null;

  //-- remove unused query params
  // uniqueParams definr in custom js 
  let urlToCheck = new URL(window.location.href);
  if (uniqueParams.has('tab')) {
    uniqueParams.delete('tab'); // remove just tab
    // rebuild URL with or without remaining params
    let newUrl = urlToCheck.pathname + (uniqueParams.toString() ? '?' + uniqueParams.toString() : '');
    window.history.replaceState({}, document.title, newUrl);
  } else if (!urlToCheck.search || urlToCheck.search === '?') {
    
    window.history.replaceState({}, document.title, urlToCheck.origin + urlToCheck.pathname);
  }
  // -- end code remove unused query params

  // Reusable function to activate product
  function activateProduct(item) {
    console.log('item----->', item);
    productGridItems.forEach(i => {
      i.classList.remove('active', 'bottom_fixed_popup');
    });

    item.classList.add('active', 'bottom_fixed_popup');

    const productTitle = item.getAttribute('data-product-planValueWithValidity');
    const productPriceSymbol = item.getAttribute('data-product-planSymbol');
    const productPriceValue = item.getAttribute('data-product-planPrice');
    // const productTitle = item.getAttribute('data-product-title');
    const productPrice = item.getAttribute('data-product-price');
    const productComparePrice = item.getAttribute('data-product-compare-price');
    const collectionTitle = item.getAttribute('data-collection-title');
    const variantId = item.getAttribute('data-variant-id');
    const preferredImsiId = item.getAttribute('data-preferred-imsi-id');
    const productId = item.getAttribute('data-product-id');
    const countryKey = item.getAttribute('data-country-key');
    const currencyKey = item.getAttribute('data-currency-key');

    selectedProductTitle = productTitle;
    selectedProductId = productId;
    selectedCountryKey = countryKey;
    selectedCurrencyKey = currencyKey;
    selectedVariantId = variantId;
    selectedPreferredImsiId = preferredImsiId;

    productNameEl.textContent = productTitle;
    // productPriceEl.textContent = productPrice;
    productPriceEl.textContent = productPriceSymbol + ' ' + productPriceValue;
    // productComparePriceEl.textContent = productComparePrice || '';
    productComparePriceEl.textContent = productComparePrice
      ? productPriceSymbol + ' ' + productComparePrice
      : '';

    collectionNameEl.textContent = collectionTitle;

    detailBox.style.display = 'block';
  }

  // auto select in based on veriant ID
  // if selected verient found in the url
  if (uniqueParams.has('selectedVariantId')){
  const veriantId = uniqueParams.get('selectedVariantId'); 
  const selectedVariantItem = document.querySelector(`[data-unique-variant-id="${veriantId}"]`);
    if (selectedVariantItem) {
      activateProduct(selectedVariantItem);
    }
  }
  // -- end auto select in based on veriant ID

  // ---- Existing binding logic ----
  productGridItems.forEach(item => {
    const topContent = item.querySelector('.card_top_content');
    if (topContent) {
      topContent.addEventListener('click', (e) => {
        e.stopPropagation();
        activateProduct(item);
      });
    }
  });

  // ---- New auto-select logic (URL-based) ----
  const esimId = urlParams.get('esimId');
  const subscriptionId = urlParams.get('subscriptions');

  if (esimId && subscriptionId) {
    const targetItem = document.querySelector(`[data-product-id="${subscriptionId}"]`);
    if (targetItem) {
      activateProduct(targetItem);
    }
  }

  // ---- New auto-select logic (bestForValue-based) ----
  if (!esimId && !subscriptionId) {
    // only run this if no URL params override
    const defaultActive = document.querySelector('#product-grid .grid__item.active');
    if (defaultActive) {
      activateProduct(defaultActive);
    }
  }

  // is for login user 
  if (window.customerData.email) {
 
    // get the esim
    //  On page load: set initial button visibility canProceedToCheckout
    // this function is responsible to show go to checkout and verification 
    // ------start selet esim
    const checkCheckoutValidation = await canProceedToCheckout(cacheData?.cache?.config?.eKycEnabled);
    console.log(uniqueParams.get('newesim'), uniqueParams.get('esimId'), 'fdfd')
    if (checkCheckoutValidation) {
      document.getElementById('e_sims_list')?.addEventListener('click', async (e) => {
        const el = e.target.closest('.arow_icn');
        if (!el) return;
        const esimId = el.dataset.esimId;
        console.log('Delegated click - eSIM ID:', esimId);

        if (typeof selectedVariantId === 'undefined' || !selectedVariantId) {
          console.warn('selectedVariantId is missing.');
          // define in costom js
          if (detailPopupSelectedVariantId == null) {
            console.warn('detail Popup SelectedVariantId is missing.', detailPopupSelectedVariantId);
            return;
          }
        }

        // which product Id go to checkout
        let productVariantId = null;
        if (selectedVariantId && detailPopupSelectedVariantId == null) {
          // it means in the select ESIm user cam from the checklout btn
          productVariantId = selectedVariantId;
        } else if (detailPopupSelectedVariantId) {
          // it means user comming from plan details
          productVariantId = detailPopupSelectedVariantId;

        }

        form.querySelector('input[name="id"]').value = productVariantId;
        form.querySelector('input[name="properties\\[esimId\\]"]').value = esimId;
        form.querySelector('input[name="properties\\[subscriptions\\]"]')?.remove();
        const formData = new FormData(form);

        try {
          await fetch('/cart/clear.js', { method: 'POST' });
          await fetch('/cart/add.js', { method: 'POST', body: formData });
          // Gtm trigger
          const pageUrl = window.location.origin + `/cart/${selectedVariantId}:1`
          initiateCheckout(selectedCountryKey, selectedProductTitle, pageUrl)
          window.location.href = '/checkout';
        } catch (error) {
          console.error('Error adding to cart or redirecting:', error);
        }
      });

      // new esim popup
      document.getElementById('get_new_eSim_checkout_popup_btn')?.addEventListener('click', async (e) => {
        console.log('clicked on get new esim');
        e.preventDefault();
        if (selectedVariantId) {
          // Redirect directly to checkout with selected variant
          // Gtm trigger
          const pageUrl = window.location.origin + `/cart/${selectedVariantId}:1`
          initiateCheckout(selectedCountryKey, selectedProductTitle, pageUrl)
          window.location.href = `/cart/${selectedVariantId}:1`;
        }

      })
    }
    // ------------ end ---selet esim 

    //  =---------Checkout Button Logic
    checkoutBtn?.addEventListener('click', async (e) => {
      e.preventDefault();
      //1. we need updated data of subscription me API
      subscriberMeData = await subscriberMe();
      //2. check is accout / email verifird
      if (!subscriberMeData || subscriberMeData.verifiedAccount !== true) {
        openEmailVerifyPopup();
        generateEmailVerifyOtp();
        return;
      }
      //3. check again canProceedToCheckout
      const finalCheckoutValidation = await canProceedToCheckout(cacheData?.cache?.config?.eKycEnabled);
      // stop if return false 
      if (!finalCheckoutValidation) {
        return false;
      }
      // gtm buynow triggered
      if (selectedProductTitle && selectedProductId && selectedCountryKey && selectedCurrencyKey) {
        buyNowClicked(selectedProductTitle, selectedProductId, selectedCountryKey, selectedCurrencyKey);
      } else {
        console.log('selected keys value not fount for the GTM');
      }
      // --- start check inventory code 
      const esimsData = await getMyESIMData(); // assuming this is async
      let eSIM = esimsData?.find(esim => esim?.imsiId === Number(selectedPreferredImsiId));
      const inventoryOk = await getInventoryCheck(selectedPreferredImsiId);
      console.log(inventoryOk, 'inventoryOk');
      if (!inventoryOk || inventoryOk?.available == false) {
       
        // -- if no new esim Inventory then check imsi id with exitign  
        await renderESIMCards(esimsData, selectedPreferredImsiId)
         //match any imsi id 
        console.log(eSIM?.imsiId, selectedPreferredImsiId)
        if (eSIM?.imsiId == selectedPreferredImsiId) {
          // As this time the inventory nor avaiable so we disable the btn 
          document.getElementById('choose_esim_for_new_esim_msg').classList.add('hidden');
          document.getElementById('choose_esim_if_no_inventory_msg')?.classList?.remove('hidden');
          document.getElementById('get_new_eSim_checkout_popup_btn').setAttribute('disabled', 'true');
          // do not show select esim for old user
          console.log('url params', uniqueParams.get('newesim'), uniqueParams.get('esimId'));
          // if params found 
          if (uniqueParams.get('newesim') == 'true' || uniqueParams.get('esimId')) {
            document.getElementById('esim_purchase_popup').classList.add('hidden');
          } else if (esimsData && esimsData.length > 0) {
            // user going to checkout from the checkout btn
            detailPopupSelectedVariantId = null;
            document.getElementById('esim_purchase_popup').classList.remove('hidden');
            return true
          }
        } else {
          console.log('not metched Imsi ID ', eSIM?.imsiId, selectedPreferredImsiId)
          document.getElementById('common_warning').classList.remove('hidden');
          document.getElementById('common_warning_msg').textContent = 'There are no eSIMs in available-state, please contact the support team';
          console.log('Inventory check failed. Cannot proceed to checkout.');
      
        }
        // ------------code end  for Choose the eSIM you want to purchase a plan for


        setTimeout(() => {
          document.getElementById('common_warning').classList.add('hidden');
        }, 3000);
        return false;
      }
      // --- End check inventory code 

      // ----------code start for Choose the eSIM you want to purchase a plan for
      // rander card first
      await renderESIMCards(esimsData, selectedPreferredImsiId);
      //match any imsi id 
      console.log(eSIM?.imsiId, selectedPreferredImsiId)
      if (eSIM?.imsiId == selectedPreferredImsiId) {
        // do not show select esim for old user
        console.log('url params', uniqueParams.get('newesim'), uniqueParams.get('esimId'));
        // if params found 
        if (uniqueParams.get('newesim') == 'true' || uniqueParams.get('esimId')) {
          document.getElementById('esim_purchase_popup').classList.add('hidden');
        } else if (esimsData && esimsData.length > 0) {
          // user going to checkout from the checkout btn
          detailPopupSelectedVariantId = null;
          document.getElementById('esim_purchase_popup').classList.remove('hidden');
          return true
        }
      } else {
        console.log('not metched Imsi ID ', eSIM?.imsiId, selectedPreferredImsiId)
      }
      // ------------code end  for Choose the eSIM you want to purchase a plan for

      if (selectedVariantId) {
        form.querySelector('input[name="id"]').value = selectedVariantId;
        ['esimId', 'subscriptions'].forEach(key => {
          const value = uniqueParams.get(key);
          let input = form.querySelector(`input[name="properties[${key}]"]`);
          if (value) {
            if (!input) {
              input = document.createElement('input');
              input.type = 'hidden';
              input.name = `properties[${key}]`;
              form.appendChild(input);
            }
            input.value = value;
          } else {
            input?.remove();
          }
        });
        const formData = new FormData(form);
        await fetch('/cart/clear.js', { method: 'POST' });
        await fetch('/cart/add.js', { method: 'POST', body: formData });

        // Gtm trigger
        const pageUrl = window.location.origin + `/cart/${selectedVariantId}:1`
        initiateCheckout(selectedCountryKey, selectedProductTitle, pageUrl)
        window.location.href = '/checkout';
      }
    });
    // end ----------- checkout logic  
    //  Verification Button Logic
    verifyBtn?.addEventListener('click', async (e) => {
      e.preventDefault();
      // we need updated of subscriber me api
      // if(subscriberMeData == null){
      subscriberMeData = null;
      subscriberMeData = await subscriberMe();
      // }
      if (!subscriberMeData || subscriberMeData.verifiedAccount !== true) {
        openEmailVerifyPopup();
        generateEmailVerifyOtp();
        return;
      }

      const ekyc = subscriberMeData.eKycStatus;
      const redirectMap = {
        pending: '/pages/verification-instructions',
        initiated: '/pages/verification-initiated',
        ongoing: '/pages/verification-initiated?status=ongoing',
        failed: '/pages/verification-status?status=failed',
        rejected: '/pages/verification-status?status=failed'
      };

      //sesstion code start
      let sessionObj = {
        "clicked_verify_identity": true,
        "page": window.location.pathname || null,
        "selectedVariantId": selectedVariantId
      };
      sessionStorage.removeItem("loggedin_user_session");
      sessionStorage.setItem("loggedin_user_session", JSON.stringify(sessionObj))
      // ----end session code 

      if (redirectMap[ekyc]) {
        window.location.href = redirectMap[ekyc];
      }

    });
  }// for geust user
  else {
    const checkoutGust = document.getElementById('checkout_gust');
     // Redirect to checkout
    checkoutGust.addEventListener('click', async (e) => {
      console.log('gust click');
      e.preventDefault();
      // gtm buynow triggered
      if (selectedProductTitle && selectedProductId && selectedCountryKey && selectedCurrencyKey) {
        buyNowClicked(selectedProductTitle, selectedProductId, selectedCountryKey, selectedCurrencyKey);
      } else {
        console.log('selected keys value not fount for the GTM');
      }
      if (!selectedVariantId) {
        console.log('selected VariantId check failed. Cannot proceed to checkout.');
      }
      // if eKYC required redirect to sinup
      if (window.collection_metafields?.eKycRequired) {
        console.log('eKYC required for this collection.', window.collection_metafields?.eKycRequired);
        // set sesstion 
        //sesstion code start when user click on checkout
        let sessionObj = {
          "clicked_verify_identity": true,
          "page": window.location.pathname || null,
          "selectedVariantId": selectedVariantId
        };
        sessionStorage.removeItem("guest_user_session");
        sessionStorage.setItem("guest_user_session", JSON.stringify(sessionObj))
        // ----end session code 
        window.location.href = '/account/login'
        return false;
      } else {
        // set sesstion 
        //sesstion code start when user click on checkout
        let sessionObj = {
          "clicked_non_verify_identity": true,
          "page": window.location.pathname || null,
          "selectedVariantId": selectedVariantId
        };
        sessionStorage.removeItem("guest_user_session");
        sessionStorage.removeItem("checkout_url");
        sessionStorage.setItem("guest_user_session", JSON.stringify(sessionObj))
      }
      // check inventory
      const inventoryOk = await getInventoryCheck(selectedPreferredImsiId);
      console.log(inventoryOk, 'inventoryOk');
      if (!inventoryOk || inventoryOk?.available == false) {
        document.getElementById('common_warning').classList.remove('hidden');
        document.getElementById('common_warning_msg').textContent = 'There are no eSIMs in available-state, please contact the support team';
        console.log('Inventory check failed. Cannot proceed to checkout.');
        setTimeout(() => {
          document.getElementById('common_warning').classList.add('hidden');
        }, 3000);
        return false;
      }
      // Redirect directly to checkout with selected variant
      const pageUrl = window.location.origin + `/cart/${selectedVariantId}:1`
      initiateCheckout(selectedCountryKey, selectedProductTitle, pageUrl)
      window.location.href = `/cart/${selectedVariantId}:1`;
    });
  }

  function planDetailsPopUp (){
    // Map API status to DOM id
    const statusIdMap = {
      success: "identity_verification_success",
      verified: "identity_verification_success",
      ongoing: "identity_verification_ongoing",
      failed: "identity_verification_failled",
      rejected: "identity_verification_failled",
      required: "identity_verification_required",
      initiated: "identity_verification_initiated",
      pending: "identity_verification_initiated",
    };
    // here not called the subscriber API because of logout out user
    const status = subscriberMeData?.eKycStatus;
    const activeId = statusIdMap[status];
    console.log("status:", status, "→ activeId:", activeId);
    // verify releted fuctionality only work if eKycEnabled
    if (activeId && cacheData?.cache?.config?.eKycEnabled) {
      // check email is verified or not
      if (subscriberMeData?.verifiedAccount == true) {
        document.getElementById(activeId)?.classList.remove('hidden');
      } else {
        //if not verified then only initiated btn will appear
        document.getElementById('identity_verification_initiated')?.classList.remove('hidden');
      }
    } else {
      console.log('eKycEnabled-', 'not login or false')
    }

    //on click on first_email_verify
    document.querySelectorAll('.first_email_verify')
    .forEach(el => {
      el.addEventListener('click', (e) => {
        if (!subscriberMeData || subscriberMeData.verifiedAccount !== true) {
          e.preventDefault();

          // close quick add modal if open
          const quickModal = document.querySelector('quick-add-modal[open]');
          if (quickModal) {
            quickModal.removeAttribute('open');
            document.body.classList.remove('overflow-hidden');
            // quickModal.style.display = 'none';
          }
          // now show your popup
          openEmailVerifyPopup();
          generateEmailVerifyOtp();
          return;
        } else {
          // go to verify your identity
        }
      });
    });

    // to set the cookies for not logged in user 
    if (!window.customerData.email) {
      // store cookies if user click on eky required from detail popup
      document.querySelectorAll('.not_logged_in_identity_required')
        .forEach(el => {
          el.addEventListener('click', (e) => {
            console.log('clicked_verify_identity');
            //sesstion code start
            let sessionObj = {
              "clicked_verify_identity": true,
              "page": window.location.pathname || null,
            };
            sessionStorage.removeItem("guest_user_session");
            sessionStorage.setItem("guest_user_session", JSON.stringify(sessionObj))
            // ----end session code 
          });
        });
    }
  }
  // --------script for details plan and its verification btn
  document.querySelectorAll('.popup_detail_btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      // -------- GTM tracking --------
      const getCountryName = window.location.pathname.split('/collections/')[1]?.split('/')[0] || '';
      planDetails(
        btn?.dataset?.productName,
        getCountryName,
        parseFloat(btn.dataset.price) / 100,
        btn.dataset?.currencyIso
      );

      // -------- Modal handling --------
      function waitForModal(retries = 3, delay = 1000) {
        setTimeout(() => {
          const popup = document.querySelector('.detail_popup_container');
          console.log('detail_popup_container', popup);

          if (popup) {
          //calling cache validation for identity and topup value
            setTopUpAvailability();
            setIdentityVerifcaton();
            planDetailsPopUp();

          } else if (retries > 0) {
            // Try again with one fewer retry
            waitForModal(retries - 1, delay);
          } else {
            console.warn('Modal not found after retries');
          }
        }, delay);
      }

      // initial call
      waitForModal(6, 1100);
    });
  });
});
